import { Dialog } from "primereact/dialog";
import { Interview_Process, IRequirementMast, Job_Type, Req_Priority, Req_Term } from "../../models/RequirementMast";
import { IAllRequirements } from "../../models/AllRequirements";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
// import { Req } from "../../shared/Req";
import { IReq_Update } from "../../models/Requirement_Update";
import { format } from "date-fns";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ILogin, } from "../../models/Login";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    singleData: IAllRequirements
    open: boolean,
    hideDialog: () => void,
    toast: any,
    typePOC?: boolean
}

export const Publish = (props: Iprops) => {
    // const [data, setData] = useState<IRequirementMast[]>([]);
    const [updatedData, setUpdatedData] = useState<IReq_Update[]>([]);
    const [hasAudio, setHasAudio] = useState(false);
    // const [additional_info,setAdditional_info] = useState("");
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props.singleData.req_ID && props.open) {
            // loadData();
            // if (props.singleData.requirement_Update) 
            loadUpdatedData();
            checkAudio();
            // else setUpdatedData([]);
        }
    }, [props.open]);

    // const loadData = async () => {
    //     setLoading(true);
    //     const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
    //     if (response) {
    //         const data: IRequirementMast[] = await response.json();
    //         setData(data);
    //         setLoading(false);
    //     } else setLoading(false);
    // }
    const loadUpdatedData = async () => {
        // setLoading(true);
        const response = await Fetch("Requirement_MAST/reqUpdate", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: IReq_Update[] = await response.json();
            // data.reverse();
            data.forEach(d => {
                d.req = JSON.parse(d.details);
            });
            if (data.length > 0) setUpdatedData(data);
            else {
                const response2 = await Fetch(`Requirement_MAST/${(props?.typePOC != null && props?.typePOC != undefined && props?.typePOC === true) ? "byIdPOC" : "byId"}`, "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
                if (response2) {
                    const data2: IRequirementMast = await response2.json();
                    const _tempData: IReq_Update = {
                        req_ID: data2.req_ID,
                        updatedOn: data2.req_PostedDateAndTime,
                        req: data2,
                        details: ""
                    }
                    setUpdatedData([_tempData]);
                }
            }
        }
        // setLoading(false);
    }

    const onHide = () => {
        setUpdatedData([]);
        props.hideDialog();
        setHasAudio(false);
    }

    const checkAudio = async () => {
        const response = await Fetch("Resume_Mast/audio", "GET", null, `req_id=${props.singleData.req_ID}`, null);
        if (response) setHasAudio(true);
    }

    const footerTemplate = () => {
        return hasAudio ? <div style={{ display: 'flex' }}>
            <audio src={`${baseUrl}${"Resume_Mast/audio"}?req_id=${props.singleData.req_ID}`} controls></audio>
        </div> : '';
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} footer={footerTemplate} header={<span>Details of Requirement ID - {(props?.typePOC != null && props?.typePOC != undefined && props?.typePOC === true) ? "" : props.singleData.req_ID}</span>} className="p-fluid" onHide={onHide} maximizable>
            {/* <Req req={data} loading={loading} /> */}
            {/* <CKEditor editor={ClassicEditor} data={data[0]?.req_JobDescription} disabled /> */}
            {updatedData.length === 0 && <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><h4>Loading...</h4></div>}
            {updatedData.map((ud, index) => {
                // let date;
                // // let str = ud.req?.additional_info ? ud.req?.additional_info.split(">")[1].split("<")[0] : "";
                // // setAdditional_info(ud.req?.additional_info || "");
                // if (ud.updatedOn) date = format(new Date(ud.updatedOn), 'dd/MM/yyyy hh:mm a').toUpperCase();
                // else date = "";
                let date = "";
                if (ud.updatedOn) {
                    const d = new Date(ud.updatedOn);
                    date = safeFormatDate(d.toDateString(), "dd/MM/yyyy", DateFormat) + " " + format(d, "hh:mm a").toUpperCase();
                }

                const parser = new DOMParser();
                const html = parser.parseFromString(ud.req?.additional_info || "<p>No Job Description</p>", 'text/html');
                const body = html.body.innerText;

                const location = ud.req?.city_Name ? `${ud.req?.city_Name || ''}, ${ud.req?.state_Name || ''}` : '';
                return <div className="mb-3" key={ud.req_Update_ID}>
                    <h6 className="text-primary">{index === updatedData.length - 1 ? "Posted On" : "Updated On"} - {date}</h6>
                    <JVSunEditor value={`<table>
    <thead>
        <th>Job Title</th>
        <th>Duration</th>
        <th>Location</th>
        <th>Job Type</th>
        <th>Rate/Salary</th>
        <th>End Client</th>
        <th>Industry</th>
        <th>Job Term</th>
        <th>Positions</th>
        <th>Skills Category</th>
        <th>Priority</th>
        <th>Travel</th>
        <th>Work Authorization</th>
        <th>Interview Process</th>
        <th>Skills Required</th>
    </thead>
    <tbody>
        <td>${ud.req?.req_Job_Title}</td>
        <td>${ud.req?.req_Duration}</td>
        <td>${location}</td>
        <td>${ud.req?.job_Type !== undefined ? Job_Type[ud.req.job_Type] : ""}</td>
        <td>${ud.req?.req_Rate}</td>
        <td>${ud.req?.req_EndClient === undefined ? "" : ud.req?.req_EndClient}</td>
        <td>${ud.req?.industry_Name === undefined ? "" : ud.req?.industry_Name}</td>
        <td>${ud.req?.req_Term !== undefined ? Req_Term[ud.req.req_Term] : ""}</td>
        <td>${ud.req?.req_NoOfPositions}</td>
        <td>${ud.req?.req_Category_Name}</td>
        <td>${ud.req?.req_Priority !== undefined ? Req_Priority[ud.req.req_Priority] : ""}</td>
        <td>${ud.req?.travelReq}</td>
        <td>${ud.req?.visa}</td>
        <td>${ud.req?.req_InterviewProcess !== undefined ? Interview_Process[ud.req.req_InterviewProcess] : ""}</td>
        <td>${ud.req?.req_RequiredSkill}</td>
    </tbody>
</table>
<p><b>Job Description -</b> \n${ud.req?.req_JobDescription}</p>`} />
                    <p className="mt-3"><b>Additional Info -</b> <br /><br /> {body}</p>
                    {/* {ud.req?.additional_info && <CKEditor disabled editor={ClassicEditor} data={ud.req?.additional_info} />} */}
                </div>
            })}
        </Dialog>
    );
}
